/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountSettingsExpirationInMonths {
    MONTH3 = 'Month3',
    MONTH6 = 'Month6',
    MONTH9 = 'Month9',
    MONTH12 = 'Month12',
}
